let increment= 0;

export default (event,data) => {
  let event_data = { event };
  let inc = 0;
  window.dataLayer = window.dataLayer || [];
  console.log("track ",event, data)
  switch(event){
    case "search_option":
      event_data.option_search_main = data.currentPage;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "search_movie":
      event_data.movie_name = data.movie_name;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "location_filter":
      event_data.option_location_filter = data.location_filter;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "location_search":
      event_data.location_name = data.location;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "cinema_search":
      event_data.cinema_name = data.cinema;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "film_id_search":
      event_data.film_id = data.film_id;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "distance_radius":
      event_data.distance = data.distance;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "date_interaction":
      event_data.date_start = data.date_start;
      event_data.date_end = data.date_end;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "submit_search":
      event_data.option_search_main = data.currentPage;
      event_data.movie_name = data.movie_name;
      event_data.option_location_filter = data.location_filter;
      event_data.location_name = data.location;
      event_data.cinema_name = data.cinema;
      event_data.film_id = data.film_id;
      event_data.distance = data.distance;
      event_data.date_start = data.date_start;
      event_data.date_end = data.date_end;
      break;
        
  }
  window.dataLayer.push(event_data);
}



// WEBPACK FOOTER //
// ./src/lib/tracking.js